
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutor-on-demand",
      function () {
        return require("private-next-pages/tutor-on-demand/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tutor-on-demand"])
      });
    }
  